/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

export const keywords = [
  { label: 'SELECT', description: null },
  { label: 'FROM', description: null },
  { label: 'WHERE', description: null },
  { label: 'GROUP', description: null },
  { label: 'BY', description: null },
  { label: 'INSERT', description: null },
  { label: 'DELETE', description: null },
  { label: 'EXPLAIN', description: 'Displays the execution plan for a statement' },
  { label: 'MERGE', description: null },
  { label: 'INTO', description: null },
  { label: 'USING', description: null },
  { label: 'WITH', description: null },
  { label: 'ALTER', description: null },
  { label: 'INDEX', description: null },
  { label: 'TABLE', description: null },
  { label: 'ADD', description: null },
  { label: 'COL', description: null },
  { label: 'COLUMN', description: null },
  { label: 'DROP', description: null },
  { label: 'SET', description: null },
  { label: 'ANALYZE', description: null },
  { label: 'CREATE', description: null },
  { label: 'COMMIT', description: null },
  { label: 'PRIMARY', description: null },
  { label: 'KEY', description: null },
  { label: 'ORDER', description: null },
  { label: 'HAVING', description: null },
  { label: 'QUALIFY', description: null },
  { label: 'DISTINCT', description: null },
  { label: 'ON', description: null },
  { label: 'OFFSET', description: null },
  { label: 'FETCH', description: null },
  { label: 'PERCENT', description: null },
  { label: 'UPDATE', description: null },
  { label: 'FOR', description: null },
  { label: 'DIRECT', description: null },
  { label: 'SORTED', description: null },
  { label: 'AS', description: null },
  { label: 'TO', description: null },
  { label: 'PLAN', description: null },
  { label: 'TABLES', description: null },
  { label: 'ROW', description: null },
  { label: 'ROWS', description: null },
  { label: 'TIES', description: null },
  { label: 'ONLY', description: null },
  { label: 'FIRST', description: null },
  { label: 'NEXT', description: null },
  { label: 'VALUES', description: null },
  { label: 'IF', description: null },
  { label: 'FALSE', description: null },
  { label: 'TRUE', description: null },
  { label: 'SPATIAL', description: null },
  { label: 'CACHED', description: null },
  { label: 'NO', description: null },
  { label: 'DATA', description: null },
  { label: 'LAST', description: null },
  { label: 'NULLS', description: null },
  { label: 'USER', description: null },
  { label: 'PASSWORD', description: null },
  { label: 'INLINE_SIZE', description: null },
  { label: 'PARALLEL', description: null },
  { label: 'TEMPLATE', description: null },
  { label: 'BACKUPS', description: null },
  { label: 'ATOMICITY', description: null },
  { label: 'ATOMIC', description: null },
  { label: 'TRANSACTIONAL', description: null },
  { label: 'TRANSACTIONAL_SNAPSHOT', description: null },
  { label: 'WRITE_SYNCHRONIZATION_MODE', description: null },
  { label: 'PRIMARY_SYNC', description: null },
  { label: 'FULL_SYNC', description: null },
  { label: 'FULL_ASYNC', description: null },
  { label: 'AFFINITY_KEY', description: null },
  { label: 'CACHE_GROUP', description: null },
  { label: 'CACHE_NAME', description: null },
  { label: 'DATA_REGION', description: null },
  { label: 'KEY_TYPE', description: null },
  { label: 'VALUE_TYPE', description: null },
  { label: 'WRAP_KEY', description: null },
  { label: 'WRAP_VALUE', description: null },
  { label: 'LOGGING', description: null },
  { label: 'NOLOGGING', description: null },
  { label: 'LIMIT', description: null },
];
